import { createStore } from 'vuex'
import getters from './getters'
import permission from './modules/permission'
import user from './modules/user'
import dict from './modules/dict'

export default createStore({
  modules: {
    permission,user,dict
  },
  getters
})
